import axios from "axios";

export const uploadFile = (empid, ak, glid, file) =>{
    const apiUrl = `https://uploading.imimg.com/uploadimage`
    const data = new FormData();
    const requestData = { 
        "MODID": "WEBERP",
        "IMAGE_TYPE": 'IILAttachment',
        "IMAGE_NAME": file.name,
        "USR_ID": glid,
        "UPLOADED_BY": empid,
        "VALIDATION_KEY": ak,
        "IMAGE": file
    }
    for(let key in requestData) {
        data.append(key, requestData[key]);
    }
    return axios.post(apiUrl, data);
}